// This file is auto-generated. Do not edit directly.
// Generated from configuration/groups/tco/document-mappings.yaml
// Run: bun run scripts/mappings/tco-make-mappings-from-yaml.ts
import { DocumentMapping } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const TRICITY_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.ADMIN_DISABILITY_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Communication",
      "Task Details: Disability Form - Action Required",
      "Task Note: Please leave appropriate notes, collect fee, and reassign task back to appropriate clinic. Please document every aspect of this process.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "TCO Front Desk - Clinic",
    displayName: "Disability Form",
    documentLabel: "Disability Form {{ signatureRequired }}",
    folder: "Patient Correspondence",
    folderMapping: "Patient Correspondence",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_DISABILITY_FORMS,
    group: "tco"
  },
  [Classification.ADMIN_FMLA_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Communication",
      "Task Details: FMLA - Action Required",
      "Task Note: Please leave appropriate notes, collect fee, and reassign task back to appropriate clinic. Please document every aspect of this process.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "TCO Front Desk - Clinic",
    displayName: "FMLA Form",
    documentLabel: "FMLA Form {{ signatureRequired }}",
    folder: "Patient Correspondence",
    folderMapping: "Patient Correspondence",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_FMLA_FORMS,
    group: "tco"
  },
  [Classification.ADMIN_OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Communication",
      "Task Details: Admin Doc - Action Required",
      "Task Note: Please leave appropriate notes, collect any appropriate fees, and reassign task back to appropriate clinic. Please document every aspect of this process.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "TCO Front Desk - Clinic",
    displayName: "Admin Document",
    documentLabel: "Admin Document {{ signatureRequired }}",
    folder: "Patient Correspondence",
    folderMapping: "Patient Correspondence",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_OTHER,
    group: "tco"
  },
  [Classification.ADMIN_PFML_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Communication",
      "Task Details: PFML - Action Required",
      "Task Note: Please leave appropriate notes and reassign task back to appropriate clinic. Please document every aspect of this process.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "TCO Front Desk - Clinic",
    displayName: "PFML Form",
    documentLabel: "PFML Form {{ signatureRequired }}",
    folder: "Patient Correspondence",
    folderMapping: "Patient Correspondence",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_PFML_FORMS,
    group: "tco"
  },
  [Classification.ADMIN_WORKERS_COMP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Communication",
      "Task Details: L&I (Worker's Comp) - Action Required",
      "Task Note: Please leave appropriate notes and reassign task back to appropriate clinic. Please document every aspect of this process.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "TCO Front Desk - Clinic",
    displayName: "L&I Document",
    documentLabel: "L&I Document {{ signatureRequired }}",
    folder: "LNI",
    folderMapping: "LNI",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_WORKERS_COMP,
    group: "tco"
  },
  [Classification.CARE_PLAN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: {{ documentType }}",
      "Task Note: Rcvd {{ documentType }} from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Care Plan",
    documentLabel: "{{ documentType }}",
    folder: "External Clinical Note",
    folderMapping: "External Clinical Note",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.CARE_PLAN,
    group: "tco"
  },
  [Classification.CLEARANCE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Communication",
      "Task Details: Clearance Request",
      "Task Note: Clearance request received from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Clearance Request",
    documentLabel: "Clearance Request {{ signatureRequired }}",
    folder: "External Clinical Note",
    folderMapping: "External Clinical Note",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.CLEARANCE_REQUEST,
    group: "tco"
  },
  [Classification.CLEARANCE_REQUEST_RESPONSE_OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Clearance Response",
      "Task Note: Clearance response received from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Clearance Response",
    documentLabel: "Clearance Request {{ signatureRequired }}",
    folder: "Pre-Certification",
    folderMapping: "Pre-Certification",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.CLEARANCE_REQUEST_RESPONSE_OTHER,
    group: "tco"
  },
  [Classification.CLEARANCE_REQUEST_RESPONSE_PRE_OP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Pre-Op Clearance Response",
      "Task Note: Pre-op clearance response received from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Pre-Op Clearance Response",
    documentLabel: "Clearance Request {{ signatureRequired }}",
    folder: "Pre-Op",
    folderMapping: "Pre-Op",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.CLEARANCE_REQUEST_RESPONSE_PRE_OP,
    group: "tco"
  },
  [Classification.DME_ORDER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Communication",
      "Task Details: DME - Action Required",
      "Task Note: DME-related doc rcvd from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "DME",
    documentLabel: "DME {{ signatureRequired }}",
    folder: "Orders & Rx",
    folderMapping: "Orders & Rx",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.DME_ORDER,
    group: "tco"
  },
  [Classification.FINANCIAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Fax Rcvd: Financial",
      "Task Note: Please review and follow-up as needed."
    ],
    assignedTo: "Billing Staff Group",
    displayName: "Financial Document",
    documentLabel: "Financial Document",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "External Routing WF",
    classification: Classification.FINANCIAL,
    group: "tco"
  },
  [Classification.FINANCIAL_LEGAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Communication",
      "Task Details: Legal Request for Financial Info",
      "Task Note: Rcvd request for financial info from {{ companyName }}. Please review and respond as needed or reassign to appropriate staff member(s)."
    ],
    assignedTo: "Billing Staff Group",
    displayName: "Financial Legal Request",
    documentLabel: "Financial Document",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "External Routing WF",
    classification: Classification.FINANCIAL_LEGAL,
    group: "tco"
  },
  [Classification.IMAGING_RESULTS_CT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "CT Results",
    documentLabel: "CT - {{ bodyPartLaterality }}{{ bodyPart }}",
    folder: "Results - Radiology",
    folderMapping: "Results - Radiology",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_CT,
    group: "tco"
  },
  [Classification.IMAGING_RESULTS_MRI]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "MRI Results",
    documentLabel: "MRI - {{ bodyPartLaterality }}{{ bodyPart }}",
    folder: "Results - Radiology",
    folderMapping: "Results - Radiology",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MRI,
    group: "tco"
  },
  [Classification.IMAGING_RESULTS_MULTI]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Multiple Imaging Results",
    documentLabel: "Multiple Imaging Results",
    folder: "Results - Radiology",
    folderMapping: "Results - Radiology",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MULTI,
    group: "tco"
  },
  [Classification.IMAGING_RESULTS_OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Imaging Result",
    documentLabel: "Imaging Result - {{ bodyPartLaterality }}{{ bodyPart }}",
    folder: "Results - Radiology",
    folderMapping: "Results - Radiology",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_OTHER,
    group: "tco"
  },
  [Classification.IMAGING_RESULTS_ULTRASOUND]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Ultrasound Results",
    documentLabel: "Ultrasound - {{ bodyPartLaterality }}{{ bodyPart }}",
    folder: "Results - Radiology",
    folderMapping: "Results - Radiology",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ULTRASOUND,
    group: "tco"
  },
  [Classification.IMAGING_RESULTS_X_RAY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "X-Ray Results",
    documentLabel: "XR - {{ bodyPartLaterality }}{{ bodyPart }}",
    folder: "Results - Radiology",
    folderMapping: "Results - Radiology",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_X_RAY,
    group: "tco"
  },
  [Classification.INSURANCE_COMMUNICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Communication",
      "Task Details: Insurance Correspondence - Action Required",
      "Task Note: Insurance correspondence received from {{ insuranceCompanyName }} — not claims-related. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Billing Staff Group",
    displayName: "Misc Insurance Communication",
    documentLabel: "Misc Insurance Communication {{ signatureRequired }}",
    folder: "Insurance Correspondence",
    folderMapping: "Insurance Correspondence",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INSURANCE_COMMUNICATION,
    group: "tco"
  },
  [Classification.JUNK]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Junk",
    documentLabel: "",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Delete",
    classification: Classification.JUNK,
    group: "tco"
  },
  [Classification.LAB_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Lab Results",
      "Task Note: Rcvd external lab results. Completed at {{ companyName }} on {{ dateOfEvent }}. Please review and follow up with appropriate clinical staff as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Lab Results",
    documentLabel: "{{ nameOfLab }} Results {{ significantFindings }}",
    folder: "Labs",
    folderMapping: "Labs",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.LAB_RESULTS,
    group: "tco"
  },
  [Classification.LEGAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Legal Doc",
      "Task Note: Please review and forward to appropriate attorney or internal staff member(s).\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Attorney",
    displayName: "Legal Document",
    documentLabel: "Legal Document {{ signatureRequired }}",
    folder: "Legal",
    folderMapping: "Legal",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LEGAL,
    group: "tco"
  },
  [Classification.MEDICAL_HISTORY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Fax Rcvd: Medical History",
      "Task Note: Rcvd medical history from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Medical History Records",
    documentLabel: "{{ clinicName }} Records",
    folder: "Medical Records",
    folderMapping: "Medical Records",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.MEDICAL_HISTORY,
    group: "tco"
  },
  [Classification.MEDICAL_HISTORY_CHART_FROM_HOSPITAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Fax Rcvd: Chart from Hospital",
      "Task Note: Rcvd patient chart from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Chart from Hospital",
    documentLabel: "{{ clinicName }} Chart from Hospital",
    folder: "External Clinical Note",
    folderMapping: "External Clinical Note",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.MEDICAL_HISTORY_CHART_FROM_HOSPITAL,
    group: "tco"
  },
  [Classification.MEDICAL_RECORD_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Communication",
      "Task Details: Medical Records Request",
      "Task Note: Medical record request received from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Medical Records - VRC",
    displayName: "Medical Record Request",
    documentLabel: "Med Records Req {{ signatureRequired }}",
    folder: "PHI Release",
    folderMapping: "PHI Release",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_RECORD_REQUEST,
    group: "tco"
  },
  [Classification.MEDICAL_RECORD_REQUEST_IMAGING_CD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Communication",
      "Task Details: Medical Records Request - STAT CD",
      "Task Note: STAT imaging record request. Burn the requested imaging to CD and send. Please Include: Body Part, Specify MRI, X-ray or CT, and Date Range.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Medical Records - TCO STAT CD - PACS Images Only",
    displayName: "Medical Record Request - Imaging CD",
    documentLabel: "Med Records Req {{ signatureRequired }}",
    folder: "PHI Release",
    folderMapping: "PHI Release",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    priority: "STAT",
    classification: Classification.MEDICAL_RECORD_REQUEST_IMAGING_CD,
    group: "tco"
  },
  [Classification.MEDICAL_RECORD_REQUEST_LEGAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Communication",
      "Task Details: Subpoena for Records - Action Required",
      "Task Note: Subpoena for medical records received from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Valerie Health Catchall",
    displayName: "Subpoena for Records",
    documentLabel: "Subpoena for Records {{ signatureRequired }}",
    folder: "Legal",
    folderMapping: "Legal",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    priority: "High",
    classification: Classification.MEDICAL_RECORD_REQUEST_LEGAL,
    group: "tco"
  },
  [Classification.MEDICAL_RECORD_REQUEST_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Medical Records Response",
      "Task Note: Rcvd {{ companyName }} response to medical record request. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Medical Records Response",
    documentLabel: "{{ companyName }} Response to Medical Records Request",
    folder: "Medical Records",
    folderMapping: "Medical Records",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.MEDICAL_RECORD_REQUEST_RESPONSE,
    group: "tco"
  },
  [Classification.NOTIFICATION_APPOINTMENT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Appointment Notification",
    documentLabel: "Appointment Notification {{ specialty }}",
    folder: "External Clinical Note",
    folderMapping: "External Clinical Note",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION_APPOINTMENT,
    group: "tco"
  },
  [Classification.NOTIFICATION_HOSPITAL_ADMIT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Hospital Admit Notice",
      "Task Note: Rcvd admit notice from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Hospital Admit Notification",
    documentLabel: "{{ clinicName }} Admit Notification",
    folder: "External Clinical Note",
    folderMapping: "External Clinical Note",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.NOTIFICATION_HOSPITAL_ADMIT,
    group: "tco"
  },
  [Classification.NOTIFICATION_HOSPITAL_DISCHARGE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Hospital Discharge Notice",
      "Task Note: Rcvd discharge notice from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Hospital Discharge Notification",
    documentLabel: "{{ clinicName }} Discharge Notification",
    folder: "External Clinical Note",
    folderMapping: "External Clinical Note",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.NOTIFICATION_HOSPITAL_DISCHARGE,
    group: "tco"
  },
  [Classification.OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Miscellaneous Doc",
      "Task Note: Miscellaneous document processed by Valerie. Please review and follow up as needed. Escalate to Valerie if a standard workflow for this type of document is needed."
    ],
    assignedTo: "Valerie Health Catchall",
    displayName: "Other",
    documentLabel: "Other",
    folder: null,
    folderMapping: null,
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "External Routing WF",
    classification: Classification.OTHER,
    group: "tco"
  },
  [Classification.PHARMACY_RELATED]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Communication",
      "Task Details: Rx Related Doc - Action Required",
      "Task Note: Rx related doc rcvd from {{ companyName }} regarding {{ medicationName }}; {{ signatureRequired }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Rx Related Document",
    documentLabel: "{{ medications }} Rx Related {{ signatureRequired }}",
    folder: "Prescriptions & Renewals",
    folderMapping: "Prescriptions & Renewals",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED,
    group: "tco"
  },
  [Classification.PRIOR_AUTHORIZATION_IMAGING_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Authorization",
      "Task Details: Imaging Prior Auth Request",
      "Task Note: Imaging PA request rcvd from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Faxes-MRI",
    displayName: "Imaging PA Request",
    documentLabel: "Imaging PA Request",
    folder: "Insurance Correspondence",
    folderMapping: "Insurance Correspondence",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.PRIOR_AUTHORIZATION_IMAGING_REQUEST,
    group: "tco"
  },
  [Classification.PRIOR_AUTHORIZATION_IMAGING_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Imaging Prior Auth Response - {{ authorizationStatus }}",
      "Task Note: Imaging PA response status: {{ authorizationStatus }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Faxes-MRI",
    displayName: "Imaging PA Response",
    documentLabel: "Imaging PA {{ authorizationStatus }}",
    folder: "Pre-Certification",
    folderMapping: "Pre-Certification",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.PRIOR_AUTHORIZATION_IMAGING_RESPONSE,
    group: "tco"
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Authorization",
      "Task Details: Medication Prior Auth Request",
      "Task Note: Medication PA request rcvd from {{ companyName }} regarding {{ medicationName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Medication PA Request",
    documentLabel: "{{ medications }} PA Request",
    folder: "Insurance Correspondence",
    folderMapping: "Insurance Correspondence",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST,
    group: "tco"
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Medication Prior Auth Response - {{ authorizationStatus }}",
      "Task Note: Medication PA response regarding {{ medicationName }} status: {{ authorizationStatus }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Medication PA Response",
    documentLabel: "{{ medications }} PA {{ authorizationStatus }}",
    folder: "Pre-Certification",
    folderMapping: "Pre-Certification",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE,
    group: "tco"
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Authorization",
      "Task Details: Procedure Prior Auth Request",
      "Task Note: Procedure PA request rcvd from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Faxes-Authorization",
    displayName: "Procedure PA Request",
    documentLabel: "Procedure PA Request",
    folder: "Insurance Correspondence",
    folderMapping: "Insurance Correspondence",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST,
    group: "tco"
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Procedure Prior Auth Response - {{ authorizationStatus }}",
      "Task Note: Procedure PA response status: {{ authorizationStatus }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Faxes-Authorization",
    displayName: "Procedure PA Response",
    documentLabel: "Procedure PA {{ authorizationStatus }}",
    folder: "Pre-Certification",
    folderMapping: "Pre-Certification",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE,
    group: "tco"
  },
  [Classification.PRIOR_AUTHORIZATION_REFERRAL_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Authorization",
      "Task Details: Referral Prior Auth Request",
      "Task Note: PA request rcvd from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Faxes-Authorization",
    displayName: "Referral PA Request",
    documentLabel: "Referral PA Request",
    folder: "Insurance Correspondence",
    folderMapping: "Insurance Correspondence",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.PRIOR_AUTHORIZATION_REFERRAL_REQUEST,
    group: "tco"
  },
  [Classification.PRIOR_AUTHORIZATION_REFERRAL_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Referral Prior Auth Response - {{ authorizationStatus }}",
      "Task Note: PA response status: {{ authorizationStatus }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Faxes-Authorization",
    displayName: "Referral PA Response",
    documentLabel: "Referral PA {{ authorizationStatus }}",
    folder: "Pre-Certification",
    folderMapping: "Pre-Certification",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.PRIOR_AUTHORIZATION_REFERRAL_RESPONSE,
    group: "tco"
  },
  [Classification.PRIOR_AUTHORIZATION_SURGERY_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Authorization",
      "Task Details: Surgery Prior Auth Request",
      "Task Note: Surgery PA request rcvd from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Faxes-Authorization",
    displayName: "Surgery PA Request",
    documentLabel: "Surgery PA Request",
    folder: "Insurance Correspondence",
    folderMapping: "Insurance Correspondence",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.PRIOR_AUTHORIZATION_SURGERY_REQUEST,
    group: "tco"
  },
  [Classification.PRIOR_AUTHORIZATION_SURGERY_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Surgery Prior Auth Response - {{ authorizationStatus }}",
      "Task Note: Surgery PA response status: {{ authorizationStatus }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Faxes-Authorization",
    displayName: "Surgery PA Response",
    documentLabel: "Surgery PA {{ authorizationStatus }}",
    folder: "Pre-Certification",
    folderMapping: "Pre-Certification",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.PRIOR_AUTHORIZATION_SURGERY_RESPONSE,
    group: "tco"
  },
  [Classification.PRIOR_AUTHORIZATION_THERAPY_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Authorization",
      "Task Details: Therapy Prior Auth Request",
      "Task Note: Therapy PA request rcvd from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Faxes-Therapy",
    displayName: "Therapy PA Request",
    documentLabel: "Therapy PA Request",
    folder: "Insurance Correspondence",
    folderMapping: "Insurance Correspondence",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.PRIOR_AUTHORIZATION_THERAPY_REQUEST,
    group: "tco"
  },
  [Classification.PRIOR_AUTHORIZATION_THERAPY_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Therapy Prior Auth Response - {{ authorizationStatus }}",
      "Task Note: Therapy PA response status: {{ authorizationStatus }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Faxes-Therapy",
    displayName: "Therapy PA Response",
    documentLabel: "Therapy PA {{ authorizationStatus }}",
    folder: "Pre-Certification",
    folderMapping: "Pre-Certification",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.PRIOR_AUTHORIZATION_THERAPY_RESPONSE,
    group: "tco"
  },
  [Classification.PROGRESS_NOTE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: External Progress Note",
      "Task Note: Rcvd external progress note from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Progress Note",
    documentLabel: "{{ companyName }} Progress Note",
    folder: "External Clinical Note",
    folderMapping: "External Clinical Note",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.PROGRESS_NOTE,
    group: "tco"
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_DISCHARGE_SUMMARY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Hospital Discharge Summary",
      "Task Note: Rcvd hospital discharge summary from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Hospital Discharge Summary",
    documentLabel: "{{ companyName }} Discharge Summary",
    folder: "External Clinical Note",
    folderMapping: "External Clinical Note",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_DISCHARGE_SUMMARY,
    group: "tco"
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_SUMMARY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Hospital Summary",
      "Task Note: Rcvd hospital summary from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Hospital Summary",
    documentLabel: "{{ companyName }} Hospital Summary",
    folder: "External Clinical Note",
    folderMapping: "External Clinical Note",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_SUMMARY,
    group: "tco"
  },
  [Classification.PROGRESS_NOTE_OPERATIVE_REPORT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: External Op Report",
      "Task Note: Rcvd external op report from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Op Report",
    documentLabel: "{{ companyName }} Op Report",
    folder: "External Clinical Note",
    folderMapping: "External Clinical Note",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.PROGRESS_NOTE_OPERATIVE_REPORT,
    group: "tco"
  },
  [Classification.PROGRESS_NOTE_PRE_OPERATIVE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: External Pre-Op Progress Note",
      "Task Note: Rcvd external pre-op progress note from {{ companyName }}. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Pre-Op Note",
    documentLabel: "{{ companyName }} Pre-Op Note",
    folder: "External Clinical Note",
    folderMapping: "External Clinical Note",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.PROGRESS_NOTE_PRE_OPERATIVE,
    group: "tco"
  },
  [Classification.PROGRESS_NOTE_PT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Communication",
      "Task Details: External PT/OT Progress Note - Action Required",
      "Task Note: Rcvd external pt/ot progress note from {{ companyName }}; response requested. Please review and follow up as needed.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "PT/OT Progress Note",
    documentLabel: "{{ companyName }} PT/OT Progress Note {{ signatureRequired }}",
    folder: "External Clinical Note",
    folderMapping: "External Clinical Note",
    inputDate: "Date of Event",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.PROGRESS_NOTE_PT,
    group: "tco"
  },
  [Classification.REFERRAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Refer",
      "Task Details: New Referral",
      "Task Note: New patient referral processed by Valerie. Note composed by the inbound referral workflow (lead + imaging + eligibility + scheduling)."
    ],
    assignedTo: "Referral cascade",
    displayName: "Referral",
    documentLabel: "Referral {{ bodyPartLaterality }}{{ bodyPart }}",
    folder: "Medical Records",
    folderMapping: "Medical Records",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Inbound Referral WF",
    priority: "Normal",
    classification: Classification.REFERRAL,
    group: "tco"
  },
  [Classification.REFERRAL_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Review",
      "Task Details: Referral Response",
      "Task Note: Referral response received from {{ companyName }}. Please review and follow up accordingly.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "Nurse for fax addressee",
    displayName: "Response to Referral",
    documentLabel: "Response to Referral",
    folder: "Referral",
    folderMapping: "Referral",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.REFERRAL_RESPONSE,
    group: "tco"
  },
  [Classification.REFERRAL_STATUS_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: [
      "Task Type: Communication",
      "Task Details: Referral Status Request",
      "Task Note: {{ referringProvider }} requesting referral status details. Please review and follow up accordingly.\n\nDocument uploaded to patient chart on {{ dateReceived }}."
    ],
    assignedTo: "TCO Front Desk - Clinic",
    displayName: "Referral Status Request",
    documentLabel: "Referral Status Request",
    folder: "Medical Records",
    folderMapping: "Medical Records",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Upload + Task",
    classification: Classification.REFERRAL_STATUS_REQUEST,
    group: "tco"
  }
} as const;
